<template>
	<div
		:id="uniqueId"
		class="amelipro-chips"
	>
		<p class="mb-0 d-inline-block amelipro-chips__text">
			<span class="truncate-text">
				{{ text }}
			</span>
		</p>
		<AmeliproIconBtn
			:btn-label="`supprimer ${text}`"
			class="ml-4 amelipro-chips__btn"
			icon="closeNoCircle"
			icon-color="ap-blue darken-1"
			icon-hover-color="ap-blue darken-2"
			large
			:title="`supprimer ${text}`"
			@click="emitClick"
		/>
	</div>
</template>

<script setup lang="ts">
	const props = defineProps({
		text: {
			type: String,
			required: true,
		},
		uniqueId: {
			type: String,
			required: true,
		},
	});

	const emit = defineEmits(['click']);
	const emitClick = () => emit('click', props.uniqueId);
</script>

<style lang="scss" scoped>
	.amelipro-chips {
		padding: 0.875rem 1rem;
		border-radius: 8px;
		background-color: $ap-blue-lighten3;
	}
</style>
